<template>
  <!-- preventing components re-render -->
  <keep-alive>
    <router-view></router-view>
  </keep-alive>
</template>

<script>
export default {
  name: 'DashboardTeam',
}
</script>

<style scoped>
.cards-section:first-of-type {
  margin-top: 0;
}

.cards-section.inactives {
  margin-bottom: 0;
}
</style>
